import { useEffect, useState } from 'react';
import {
    GetUserPropertyRelationshipQuery,
    GetUserPropertyRelationshipDocument
} from './GetUserPropertyRelationship.generated';
import { fetchGraphql } from '@zoopla/fetch-graphql';
import { isMyHomeRelationship } from '@zoopla/map-relationship';

const IS_HOMEOWNER_KEY = 'hm-notifications-is-homeowner';

const determineIsHomeOwner = async () => {
    try {
        const { data } = await fetchGraphql<GetUserPropertyRelationshipQuery>(
            GetUserPropertyRelationshipDocument,
            undefined
        );

        return isMyHomeRelationship(
            data?.user?.trackedProperties?.items[0].relationship
        );
    } catch {
        return false;
    }
};

/**
 * Checks whether a user has tracked any properties with a homeowner or landlord relationship.
 *
 * Result cached for session duration.
 */
export const useIsHomeOwner = (isAnonSession: boolean) => {
    const [isHomeOwner, setIsHomeOwner] = useState(false);

    useEffect(() => {
        if (isAnonSession) return;
        let ignore = false;

        const cachedValue = sessionStorage.getItem(IS_HOMEOWNER_KEY);

        if (cachedValue) {
            setIsHomeOwner(JSON.parse(cachedValue));
            return;
        }

        (async () => {
            const trackedPropertyAsHomeOwner = await determineIsHomeOwner();
            if (!ignore) {
                sessionStorage.setItem(
                    IS_HOMEOWNER_KEY,
                    JSON.stringify(trackedPropertyAsHomeOwner)
                );
                setIsHomeOwner(trackedPropertyAsHomeOwner);
            }
        })();

        return () => {
            ignore = true;
        };
    }, [isAnonSession]);

    return isHomeOwner;
};
